"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBCheckbox", {
  enumerable: true,
  get: function get() {
    return _SVBCheckbox.default;
  }
});
var _SVBCheckbox = _interopRequireDefault(require("./src/SVBCheckbox"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }